<template>
  <div class="single-select-choice">
    <van-popover @close="onClosePopover" @open="onOpenPopover" v-model="popup" trigger="click" placement="bottom-start">
      <ul class="select-group pt-2">
        <li v-for="item in showItems" :key="item.id" class="select-item" @click="onConfirm(item)">
          <div>
            <span>{{ item.text }}</span>
          </div>
        </li>
        <li v-if="!showItems.length" class="select-item">
          <div>
            <span>暂无数据</span>
          </div>
        </li>
      </ul>
      <template v-slot:reference>
        <van-field
          @click="onFocus"
          :readonly="!issue.enableFilter"
          :placeholder="placeholder"
          right-icon="arrow-down"
          v-model="inputValue"
        />
      </template>
    </van-popover>
    <template v-if="selectItem">
      <van-field placeholder="请输入" v-if="selectItem.is_other_item" v-model="selectItem.value" class="my-2" />
    </template>
    <div class="vote-answer vote-answering-wrapper" v-if="showVoteProgress && changeExpr">
      <template v-if="voteItems.length">
        <div style="margin-bottom: 12px">
          投票排名
        </div>
      </template>
      <choice-vote-content :items="voteItems" />
      <template v-if="voteItems.length > 5">
        <van-button type="primary" size="small" block @click="onShowMoreRank">查看更多排名</van-button>
      </template>
    </div>
  </div>
</template>

<script>
import { transformRichText2Text } from 'dygc'

import selectVote from './select-vote'
export default {
  name: 'SingleSelectChoice',
  changeExpr: 'changeExpr',
  mixins:[selectVote],
  data() {
    return {
      fieldValue: '',
      popup: false,
      inputValue: '',
      selectItem: null
    }
  },
  computed: {
    changeExpr() {
      let item = this.issue.getItemById(this.issue.select)
      if (item) {
        return item.id + item.value + item.content.fileList.length
      } else {
        return ''
      }
    },
    placeholder() {
      if (this.fieldValue && this.popup) {
        return this.fieldValue
      } else {
        return this.issue.placeholder || '请选择'
      }
    },
    showItems() {
      const searchValue = this.inputValue
      return this.items.filter(item => item.text.includes(searchValue))
    },
    items() {
      return this.issue.items.map(item => {
        return {
          text: transformRichText2Text(item.content.richText),
          id: item.id
        }
      })
    }
  },
  methods: {
    onFocus() {
      if (this.popup) {
        this.popup = false
      }
    },
    onOpenPopover() {
      this.inputValue = ''
    },
    onClosePopover() {
      this.inputValue = this.fieldValue
    },
    onCancel() {
      this.popup = false
    },
    onConfirm(val) {
      this.issue.select = val.id
      this.$emit('change')
      this.popup = false
    },
    selectValue(val) {
      let item = this.items.find(item => item.id === val)
      if (item) {
        this.selectItem = this.issue.items.find(item => item.id === val)
        this.fieldValue = item.text
        this.inputValue = this.fieldValue
      }
    }
  },
  watch: {
    'issue.select'(val) {
      this.selectValue(val)
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.issue.select) {
        this.selectValue(this.issue.select)
      }
    })
  }
}
</script>

<style scoped></style>
